import type { IconAsset } from '../Icon.types';

export const user: IconAsset = {
  bold: {
    l: {
      code: (
        <g>
          <path
            clipRule='evenodd'
            d='M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z'
            fill='currentColor'
            fillRule='evenodd'
          />
          <path d='M21 21V18H3V21H21Z' fill='currentColor' />
        </g>
      ),
    },
    m: {
      code: (
        <g>
          <path
            clipRule='evenodd'
            d='M15 7C15 9.76142 12.7614 12 10 12C7.23858 12 5 9.76142 5 7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7Z'
            fill='currentColor'
            fillRule='evenodd'
          />
          <path d='M18 18V15H2V18H18Z' fill='currentColor' />
        </g>
      ),
    },
    s: {
      code: (
        <g>
          <path
            d='M8 9C10.2091 9 12 7.20914 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.20914 5.79086 9 8 9Z'
            fill='currentColor'
          />
          <path d='M14 14V11H2V14H14Z' fill='currentColor' />
        </g>
      ),
    },
  },
};
